import styled, { keyframes } from "styled-components";

const barEnter = keyframes`
  from {
    opacity: 0;
    transform: translateY(90px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const badgePop = keyframes`
  0% { transform: scale(1); }
  45% { transform: scale(1.3); }
  100% { transform: scale(1); }
`;

export const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 14px 26px;
  z-index: 40;
  pointer-events: none;
  display: flex;
  justify-content: center;
`;

export const Bar = styled.button`
  pointer-events: auto;
  width: 100%;
  max-width: 452px;
  border: none;
  cursor: pointer;
  border-radius: ${(p) => p.theme.tokens.radii.lg}px;
  background: ${(p) => p.theme.tokens.gradients.button};
  color: #fff;
  padding: 13px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: ${(p) => p.theme.tokens.shadows.floating};
  font-family: ${(p) => p.theme.tokens.font.family};
  -webkit-tap-highlight-color: transparent;
  animation: ${barEnter} 0.38s ${(p) => p.theme.tokens.transition.spring} both;
  transition: transform 0.12s ease;

  &:active {
    transform: scale(0.98);
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const CountBadge = styled.span`
  width: 30px;
  height: 30px;
  border-radius: ${(p) => p.theme.tokens.radii.sm}px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 14px;
  flex-shrink: 0;
  animation: ${badgePop} 0.3s ease;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const Label = styled.span`
  font-weight: 900;
  font-size: 15.5px;
  flex: 1;
  text-align: left;
`;

export const Total = styled.span`
  font-weight: 900;
  font-size: 16px;
`;
